<template>
	<v-navigation-drawer class="mainNavDrawer"
		v-model="drawer"
		color="primary"
		dark	
		app>
		<UserForm ref="UserForm" @user-updated="delayRefresh()"></UserForm>
		<v-list
			dense
			nav
			class="py-0">
			<v-list-item two-line>
				<v-list-item-avatar>
					<img src="/img/korphil_logo.jpg">
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title>KorPhil Davao</v-list-item-title>
					<v-list-item-subtitle>Online EMS</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

				<!-- v-for="category in $lodash.orderBy(categories, 'title')" -->
			<div v-for="link in links" :key="link.text">

				<v-divider v-if="link.divider" class="ma-1 mt-2"></v-divider>

				<v-list-item link v-else-if="!link.sublinks" class="mb-1"
					@click="redirect(link.route, link.click)"
					v-show="checkAccess(link.requires)">
					<v-list-item-icon>
						<v-icon>{{ link.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ link.text }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group v-else-if="link.sublinks"
					:prepend-icon="link.icon"
					no-action>
					<template v-slot:activator>
						<v-list-item-content>
							<v-list-item-title>{{ link.text }}</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item link
						v-for="sublink in link.sublinks" :key="sublink.text"
						@click="redirect(sublink.route)">
						<v-list-item-content>
							<v-list-item-title>
								{{ sublink.text }}
							</v-list-item-title>
						</v-list-item-content>
						<v-list-item-icon>
							<v-icon small>{{ sublink.icon }}</v-icon>
						</v-list-item-icon>
					</v-list-item>
				</v-list-group>

			</div>

		</v-list>
	</v-navigation-drawer>
</template>

<style scoped>
	.v-avatar img {
		margin-top: 2.5px;
	}
</style>

<style>
	.mainNavDrawer .v-icon.fa {
		width: 30px;
	}
	.v-list .v-list-item--active {
		color: #FFF; /* TEMPORARY FIX */
	}
	.v-navigation-drawer__content::-webkit-scrollbar {
			cursor: pointer !important;
			width: 0.5em;
	}

	.v-navigation-drawer__content::-webkit-scrollbar-track {
			cursor: pointer !important;
			box-shadow: inset 0 0 6px rgba(0,0,0,0.0);
	}

	.v-navigation-drawer__content::-webkit-scrollbar-thumb {
			cursor: pointer !important;

			border-radius: 10px;
			background-color: rgba(0,0,0,0.15);
			outline: 1px solid rgba(0,0,0,0.15);
	}

	.v-list-group__items .v-list-item__title {
		padding-left: 6px;
	}
</style>

<script>
import { ROUTE, USER } from '../../services/constants'
import Auth from '../../services/auth'
import UserForm from '../user/UserForm'

export default {
	name: 'NavDrawer',
	components: { UserForm },
	data () {
		return {
			ROUTE,
			Auth,
			drawer: null,
			categories: [],
			isVisible: this.drawer,
			links: [
				{
					text: 'Home',
					icon: 'fa-home',
					requires: [],
					route: ROUTE.HOME,
				},
				{
					text: 'SMS',
					icon: 'fa-envelope',
					requires: [ USER.ADMIN, USER.TEACHER, USER.REGISTRAR, USER.TRAINING ],
					route: ROUTE.SMS,
				},
				{
					text: 'Users',
					icon: 'fa-users',
					requires: [ USER.ADMIN ],
					route: ROUTE.USERS,
				},
				{
					text: 'Courses',
					icon: 'fa-book',
					requires: [ USER.ADMIN, USER.REGISTRAR, USER.TRAINING  ],
					route: ROUTE.COURSES,
				},
				{
					text: 'Registrations',
					icon: 'fa-edit',
					requires: [ USER.ADMIN, USER.REGISTRAR ],
					route: ROUTE.REGISTRATIONS,
				},
				{
					text: 'SIDs',
					icon: 'fa-barcode',
					requires: [ USER.ADMIN, USER.REGISTRAR, USER.IT ],
					route: ROUTE.SIDS,
				},
				{
					text: 'Exam Results',
					icon: 'fa-tasks',
					requires: [ USER.ADMIN, USER.REGISTRAR ],
					route: ROUTE.EXAMS,
				},
				{
					text: 'Questions',
					icon: 'fa-book',
					requires: [ USER.ADMIN, USER.REGISTRAR ],
					route: ROUTE.QUESTIONS,
				},
				// {
				// 	text: 'Enroll',
				// 	icon: 'fa-user-check',
				// 	requires: [ USER.ADMIN, USER.REGISTRAR ],
				// 	route: ROUTE.ENROLL,
				// },
				{
					text: 'Reports',
					icon: 'fa-print',
					sublinks: [
						{
							text: 'Enrollees',
							icon: 'fa-user-check',
							route: ROUTE.ENROLLEE_REPORT,
						},
					],
				},

				{ divider: true },

				{
					text: 'Settings',
					icon: 'fa-cog',
					requires: [ USER.ADMIN , USER.REGISTRAR, USER.TRAINING, USER.TEACHER ],
					click: () => {
						let user = Auth.getLoggedUser();
						this.$refs.UserForm.updateUser(user.id, true);
					}
				},
				{
					text: 'Logout',
					icon: 'fa-sign-out-alt',
					click: () => {
						Auth.logout();
					}
				},
			]
		}
	},
	methods: {
		redirect(route, click) {
			if(route) {
				this.$router.push({ name: route }).catch(() => {});
			} else if(click) {
				click();
			}
		},

		checkAccess(typeArr) {
			if(!typeArr || typeArr.length == 0) {
				return true;
			}

			for(let i=0; i<typeArr.length; i++) {
				if(Auth.isType(typeArr[i])) {
					return true;
				}
			}

			return false;
		},

		delayRefresh() {
			setTimeout(() => {
				this.$router.go();
			}, 1000);
		}

	}
}
</script>